import { useSelector } from "react-redux";
import ContractCard from "./ContractCard";

const ContractData = () => {
  const { contracts } = useSelector((state) => state.contracts);

  const tableHead = [
    { id: 1, label: "Ad" },
    { id: 2, label: "Müqavilə növü" },
    { id: 3, label: "Status" },
    { id: 4, label: "Müqavilə faylı" },
    { id: 5, label: "" },
  ];

  return (
    <div>
      <table className={`details-table  courses-table`}>
        <thead>
          <tr>
            {tableHead.map((head, i) => (
              <>
                <th className={`table-head-w`} key={i}>
                  {head.label}
                </th>
              </>
            ))}
          </tr>
        </thead>

        <tbody>
          {contracts?.map((contract, i) => (
            <ContractCard
              key={contract._id}
              data={contract}
              mode="desktop"
              cellNumber={i + 1}
              setOpenMoreModal={() => {}}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ContractData;
